import { authenticatedFetch } from "./authenticatedFetch";
import { parseApiResponseBody } from "../utils/parseApiResponseBody";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export async function fetchUnreadCount() {
  const res = await authenticatedFetch(`${API_BASE_URL}/notifications/unread-count`, {
    credentials: 'include'
  });

  if (!res.ok) {
    throw new Error('Failed to fetch unread count');
  }

  return res.json();
}

export async function fetchNotifications({ limit = 20, nextToken } = {}) {
  const params = new URLSearchParams();
  params.append('limit', limit);
  if (nextToken) params.append('nextToken', nextToken);

  const res = await authenticatedFetch(
    `${API_BASE_URL}/notifications?${params.toString()}`,
    { credentials: 'include' }
  );

  if (!res.ok) {
    throw new Error('Failed to fetch notifications');
  }

  const data = await parseApiResponseBody(res);

  return {
    items: data?.notifications || [],
    nextToken: data?.nextToken ?? null
  };
}

export async function markAsRead(id, createdAt) {
  await authenticatedFetch(
    `${API_BASE_URL}/notifications/${id}/read?createdAt=${encodeURIComponent(createdAt)}`,
    {
      method: 'POST',
      credentials: 'include'
    }
  );
}

export async function deleteNotification(id, createdAt, options = {}) {
  const { confirmLicenseAction = false } = options;
  const params = new URLSearchParams({
    createdAt: String(createdAt),
  });
  if (confirmLicenseAction) {
    params.set('confirmLicenseAction', 'true');
  }

  const response = await authenticatedFetch(
    `${API_BASE_URL}/notifications/${id}?${params.toString()}`,
    {
      method: 'DELETE',
      credentials: 'include'
    }
  );

  if (!response.ok) {
    let message = 'Erro ao remover notificação';

    try {
      const data = await response.json();
      message = data?.message || data?.error || message;
    } catch (_) { }

    const error = new Error(message);
    error.statusCode = response.status;
    throw error;
  }

  return true;
}

export async function cleanNotifications() {
  let response = await authenticatedFetch(
    `${API_BASE_URL}/clean-notifications`,
    {
      method: 'DELETE',
      credentials: 'include'
    }
  );

  return response.json();
}


